import Constants from '../utils/constants';
import BaseServiceCrud from './BaseServiceCrud';
import moment from 'moment';

export default class TransportService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'transport';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria.locale,
            name: criteria?.name,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }
    getDetailsList(criteria) {
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/details/list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    update(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'PUT',
            body: JSON.stringify(this.createObjectToSave(element)),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    add(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'POST',
            body: JSON.stringify(this.createObjectToSave(element)),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    createObjectToSave(element) {
        const e = this.cloneElement(element);
        console.log(e);
        
        console.log(e);
        return e;
    }

    removeTransport(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getTransportDictTypes() {
        return this.fetch(`${this.domain}/${this.path}/transport-types`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
